import { render, staticRenderFns } from "./Customizacao.vue?vue&type=template&id=2a77d850&scoped=true&"
import script from "./Customizacao.vue?vue&type=script&lang=js&"
export * from "./Customizacao.vue?vue&type=script&lang=js&"
import style0 from "./Customizacao.vue?vue&type=style&index=0&id=2a77d850&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a77d850",
  null
  
)

export default component.exports